/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
//   import config from "../../config/suspendUser.config.json";
import { notificationConfig } from '../../config/notifications.config';
import axios from 'axios';

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { SUSPEND_USER } from '../../config/api/graphql';
import { vappContainer } from '@/application';

const getGraphQLModule = () => {
  return vappContainer.get<GraphqlServerModule>(GraphqlServerModule.name);
};
export interface suspendUserProps {
  ids: any;
}

export interface ISuspendUserMethods extends IPluginMethodMap {
  getSuspendUser(args: suspendUserProps): Promise<any>;
}

export class SuspendUserService implements IAgentPlugin {
  readonly methods: ISuspendUserMethods;

  constructor() {
    this.methods = {
      getSuspendUser: this.getSuspendUser.bind(this),
    };
  }

  async getSuspendUser(args: suspendUserProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    try {
      if (client) {
        const res = await client.mutate({
          mutation: SUSPEND_USER,
          variables: {
            vuid: args,
          },
          fetchPolicy: 'no-cache',
        });
        if (res?.data?.suspendUser) {
          return {
            ...res?.data?.suspendUser,
            notification: notificationConfig?.suspendUserSuccess,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
